import { render, staticRenderFns } from "./LoadingCup.vue?vue&type=template&id=3a8eadca&scoped=true&"
import script from "./LoadingCup.vue?vue&type=script&lang=js&"
export * from "./LoadingCup.vue?vue&type=script&lang=js&"
import style0 from "./LoadingCup.vue?vue&type=style&index=0&id=3a8eadca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8eadca",
  null
  
)

export default component.exports